import appSettings from '@/app-settings.json';
import { ICellRendererFunc } from '@ag-grid-community/core';
import { AGGridEstimatedTaxCellRenderer } from 'deckard-ui/dist/components/AGGridTable/cell-renderers/estimated-tax-cell/ag-grid-estimated-tax-cell-renderer';
import { renderToString } from 'react-dom/server';

// TODO: DECK-27285 Remove when tax estimations is ready
const taxEstimationsFeatureEnabled =
  appSettings?.uiConfigPayload?.taxEstimations;

export const EstimatedTaxCellRenderer: ICellRendererFunc = (params) => {
  if (!taxEstimationsFeatureEnabled) return '';

  const taxEstimation = params.data.taxEstimation;
  const discrepancyInvestigated = params.data.discrepancyInvestigated;

  return renderToString(
    <AGGridEstimatedTaxCellRenderer
      taxEstimation={taxEstimation}
      discrepancyInvestigated={discrepancyInvestigated}
    />
  );
};
